import { CheckedAddress } from '@sparkdotfi/common-universal'
import { StateCreator } from 'zustand'

import { StoreState, useStore } from '.'

export interface Governance {
  welcomeDialogViewedAddresses: CheckedAddress[]
  addToWelcomeDialogViewedAddresses: (address: CheckedAddress) => void
}

export interface GovernanceSlice {
  governance: Governance
}

// eslint-disable-next-line func-style
export const initGovernanceSlice: StateCreator<StoreState, [], [], GovernanceSlice> = (set) => ({
  governance: {
    welcomeDialogViewedAddresses: [],
    addToWelcomeDialogViewedAddresses: (address: CheckedAddress) => {
      set((state) => ({
        governance: {
          ...state.governance,
          welcomeDialogViewedAddresses: [...state.governance.welcomeDialogViewedAddresses, address],
        },
      }))
    },
  },
})

export interface PersistedGovernanceSlice {
  governance: {
    welcomeDialogViewedAddresses?: CheckedAddress[]
  }
}

export function persistGovernanceSlice(state: StoreState): PersistedGovernanceSlice {
  return {
    governance: {
      welcomeDialogViewedAddresses: state.governance.welcomeDialogViewedAddresses,
    },
  }
}

export interface UseGovernanceWelcomeResults {
  welcomeDialogViewedAddresses: CheckedAddress[]
  addToWelcomeDialogViewedAddresses: (address: CheckedAddress) => void
}

export function useGovernanceStore(): UseGovernanceWelcomeResults {
  const { welcomeDialogViewedAddresses, addToWelcomeDialogViewedAddresses } = useStore((state) => state.governance)

  return {
    welcomeDialogViewedAddresses,
    addToWelcomeDialogViewedAddresses,
  }
}
